import { getEnvVar } from 'utils/env';
import { RosterSampleOperation } from 'lib/roster/sampleDownloads';
import {
  StoryvineRestApiOperation,
  StoryvineRestApiOperationInput,
  StoryvineRestApiOperationOutput,
} from './types/api';

import { restAuthMiddleware } from './auth';
import { merge } from 'lodash';
import { GenericRestClient } from './GenericClient';

export class StoryvineRestClient extends GenericRestClient<
  StoryvineRestApiOperation,
  StoryvineRestApiOperationInput,
  StoryvineRestApiOperationOutput
> {
  static API_URL_BASE = getEnvVar('REACT_APP_REST_API');

  constructor() {
    super({
      baseURL: StoryvineRestClient.API_URL_BASE,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Interceptor to apply the resolved request context (auth and platform headers in this case)
    this.client.interceptors.request.use(
      async (config) => {
        const resolvedRequestContext = await restAuthMiddleware(config);
        return merge(config, resolvedRequestContext);
      },
      (error) => Promise.reject(error)
    );
  }

  mediaSlice = this.createRequest('media-slice', 'post', {
    responseType: 'arraybuffer',
  });

  rosterSample = (operation: RosterSampleOperation) =>
    this.request<undefined, ArrayBuffer>(operation, undefined, 'get', {
      responseType: 'arraybuffer',
    });

  openUtilizationReportPreview = (reportId: string, signal: AbortSignal): Promise<Response> =>
    this.stream(`utilization-reports/${encodeURIComponent(reportId)}/preview`, signal);

  protected async streamHeaders(): Promise<Record<string, string>> {
    const { headers } = await restAuthMiddleware({ headers: {} });

    return headers;
  }
}
